import PropTypes from 'prop-types';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks';

import {
  HeaderBox, UserText, TitleText, HeaderTitleUser, HeaderTitleText
} from './card.styles';

export const CardHeader = ({ user, className }) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return (
    <HeaderBox className={className}>
      {isMobile ? (
        <>
          <UserText size="xl" color="focus00">{user}</UserText>
          <TitleText size="xl" color="focus00">My Archetypes</TitleText>

        </>
      )
        : (
          <>
            <HeaderTitleUser variant="sm" color="focus00">{user}</HeaderTitleUser>
            <HeaderTitleText variant="sm" color="focus00">My Archetypes</HeaderTitleText>
          </>
        )}
    </HeaderBox>
  );
};

CardHeader.propTypes = {
  user: PropTypes.string
};

CardHeader.defaultProps = {
  user: 'User'
};
